import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Navbar as BootstrapNavbar, Container, Nav } from 'react-bootstrap';
import styled from 'styled-components';

const StyledNavbar = styled(BootstrapNavbar)`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.small};
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
`;

const NavLink = styled(Nav.Link)<{ $isActive?: boolean }>`
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.primary : theme.colors.text.secondary} !important;
  font-weight: ${({ $isActive }) => ($isActive ? '600' : '500')};
  font-size: 1rem;
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm} !important;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  transition: all 0.2s ease;
  background-color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.surface.light : 'transparent'};

  &:hover {
    color: ${({ theme }) => theme.colors.primary} !important;
    background-color: ${({ theme }) => theme.colors.surface.light};
  }
`;

const LogoImage = styled.img`
  height: 50px;
  width: auto;
  object-fit: contain;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const Navbar = () => {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  const handleNavClick = (path: string) => {
    setExpanded(false);
    navigate(path);
  };

  return (
    <StyledNavbar expand="lg" fixed="top" expanded={expanded}>
      <Container>
        <BootstrapNavbar.Brand
          as={Link}
          to="/"
          onClick={() => setExpanded(false)}
        >
          <LogoImage src="/lelo_gvulot_logo.png" alt="מזרח ללא גבולות" />
        </BootstrapNavbar.Brand>
        <BootstrapNavbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded(expanded ? false : true)}
        />
        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <NavLink
              onClick={() => handleNavClick('/')}
              $isActive={isActive('/')}
            >
              דף הבית
            </NavLink>
            <NavLink
              onClick={() => handleNavClick('/international')}
              $isActive={isActive('/international')}
            >
              יעדים במזרח
            </NavLink>
            {/* <NavLink onClick={() => handleNavClick('/calculator')} $isActive={isActive('/calculator')}>
              מחשבון הוצאות
            </NavLink> */}
            <NavLink
              onClick={() => handleNavClick('/about')}
              $isActive={isActive('/about')}
            >
              אודות הבלוג
            </NavLink>
            <NavLink
              onClick={() => handleNavClick('/contact')}
              $isActive={isActive('/contact')}
            >
              צרו איתנו קשר
            </NavLink>
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </StyledNavbar>
  );
};

export default Navbar;
